import type { ContentFieldsOwner } from '@eliadmin/core/src/api/content-fields/content-fields-types';
import {
  getContentTextFields,
  omitMappedContentText,
} from '@eliadmin/core/src/api/content-fields/content-text-mapping';
import { getTourVideoMappings } from './tour-videos';
const ids = [1, 4, 5, 6, 7, 8, 9];
const mappings = ids.map(groupId => ({
  groupId,
  component: 'same-name-text' as const,
  itemIndex: 0,
}));
export function getTourContentTexts(owner: ContentFieldsOwner) {
  return getContentTextFields(owner, mappings);
}
export function getTourRemainingContent(owner: ContentFieldsOwner) {
  return omitMappedContentText(owner, [
    ...mappings.filter(mapping => mapping.groupId === 1 || mapping.groupId === 9),
    ...getTourVideoMappings(owner),
  ]);
}
